import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
const RowsTemplate = ({
  classes,
  containerStyles,
  components,
  numberOfRows,
  renderRow
}) => {
  const rows = [];
  let i;
  for (i = 1; i < numberOfRows + 1; i++) {
    const component = components[i] ? components[i] : null;
    rows.push(/*#__PURE__*/React.createElement("div", {
      key: i,
      className: classes.row
    }, renderRow(i, component)));
  }
  const isOnline = navigator.onLine;
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.container} ${containerStyles}`
  }, rows);
};
const styles = () => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  row: {
    width: "100%",
    height: "100%",
    backgroundColor: "inherit"
  }
});
export default withStyles(styles)(RowsTemplate);
RowsTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  numberOfRows: PropTypes.number.isRequired,
  containerStyles: PropTypes.string,
  renderRow: PropTypes.func.isRequired
};